export default __webpack_public_path__ + "static/media/forgot_password.06133501.svg";